export default {
  default: [
    {
      path: "/partner",
      name: "partners.table",
      component: () => import("./views/PartnersTableView.vue")
    },
    {
      path: "/partner/aanmaken",
      name: "partners.create",
      component: () => import("./views/PartnerFormView.vue")
    },
    {
      path: "/partner/:id/wijzigen",
      name: "partners.edit",
      component: () => import("./views/PartnerFormView.vue")
    },
    {
      path: "/partner/:id/v1-redirect",
      redirect: { name: "partners.view" }
    },
    {
      path: "/partner/:id",
      name: "partners.view",
      component: () => import("./views/PartnerDetailsView.vue"),
      redirect: { name: "partners.view.advisors" },
      children: [
        {
          path: "adviseurs",
          name: "partners.view.advisors",
          component: () => import("./views/PartnerDetails/AdvisorsView.vue")
        },
        {
          path: "spaarders",
          name: "partners.view.funders",
          component: () => import("./views/PartnerDetails/FundersView.vue")
        },
        {
          path: "details",
          name: "partners.view.details",
          component: () => import("./views/PartnerDetails/DetailsView.vue")
        },
        {
          path: "reports",
          name: "partners.view.reports",
          component: () => import("./views/PartnerDetails/ReportsView.vue")
        },
        {
          path: "financeReceivers",
          name: "partners.view.financeReceivers",
          component: () => import("./views/PartnerDetails/FinanceReceiversView.vue")
        }
      ]
    }
  ]
};
